<template>
  <div>
    <h1 class="title">Profile</h1>
    <v-container fluid>
      <v-row align="start" justify="center">
        <v-col
          cols="10"
          xl="3"
          lg="3"
          md="4"
          sm="8"
          xs="10"
        >
          <!-- <v-card width="500" class="mx-auto mt-5"> -->
          <v-card height="100%">
            <v-card-title class="justify-center">
              <span class="headline">Profile</span>
            </v-card-title>
            <v-card-text>  
              <v-container>
                <v-row>
                  <v-col cols="3" class="font-weight-bold body text-left">Name</v-col>
                  <v-col cols="9" class="font-weight-regular body text-left">{{ adminUserData.adminName }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="font-weight-bold body text-left">Email</v-col>
                  <v-col cols="9" class="font-weight-regular body text-left">{{ adminUserData.username }}</v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                @click="dialogNewPassword = true"
                v-bind="size"
                color="#173862"
                dark
              >
                Change Password
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- CHANGE PASSWORD MODAL STAR -->
    <v-dialog v-model="dialogNewPassword" persistent max-width="400px">
      <v-card class="pa-3">
        <v-card-title class="justify-center">
          <span class="headline">Change Password</span>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form ref="changePasswordForm" v-model="newPasswordFormValidity" @submit.prevent="saveNewPassword">
            <v-container>
              <v-row>
                <v-col cols="12" class="px-0">
                  <v-text-field 
                    label="Password*" 
                    :type="showPassword ? 'text' : 'password'"
                    v-model="newpassword"
                    :rules="passwordRules"
                    prepend-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    tabindex="1"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-0">
                  <v-text-field 
                    label="Password Confirmation*" 
                    :type="showConfirmPassword ? 'text' : 'password'"
                    v-model="newpasswordConfirmation"
                    :rules="newpasswordConfirmationRules.concat(newPasswordConfirmationRule)"
                    prepend-icon="mdi-lock"
                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showConfirmPassword = !showConfirmPassword"
                    tabindex="2"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn color="red darken-1" dark class="ma-1" @click="closeNewPasswordDialog()" tabindex="3">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogNewPasswordConfirm = true"
            :disabled="!newPasswordFormValidity"
            color="green darken-1"
            dark
          >
            Save
          </v-btn>
          <ConfirmDialog
            v-if="dialogNewPasswordConfirm"
            :confirmDialogShow="dialogNewPasswordConfirm"
            @confirm-dialog-close="dialogNewPasswordConfirm = false"
            @confirm-dialog-save="saveNewPassword"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- CHANGE PASSWORD MODAL END -->
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import admin from '../api/adminOps'
  import resizeMixin from '../mixins/resizeMixins'

  export default {
    mixins: [resizeMixin],
    components: {
      ConfirmDialog: () => import('@/components/ConfirmDialog')
    },
    data: () => ({
      adminUserData: {},
      dialogNewPassword: false,
      dialogNewPasswordConfirm: false,
      newPasswordFormValidity: false,
      newpassword: '',
      newpasswordConfirmation: '',
      newpasswordConfirmationRules: [
        value => !!value || 'Password is required.'
      ],
      passwordRules: [
        value => !!value || 'Password is required.',
        value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
            return (
              pattern.test(value) ||
              "Min. 8 characters with at least one capital letter, a number and a special character."
            );
        }
      ],
      showPassword: false,
      showConfirmPassword: false
    }),
    created () {
      this.adminUserData = this.$store.getters['users/getAdminData'];
    },
    methods: {
      showSnack: function (snack, isError) {
        const setSnackObj = {
          message: snack,
          isError: !!isError
        }
        this.setSnack(setSnackObj)
      },
      ...mapMutations({
        setSnack: 'setSnack'
      }),
      resetPasswordForm () {
        this.$refs.changePasswordForm.reset()
      },
      resetPasswordValidation () {
        this.$refs.changePasswordForm.resetValidation()
      },
      closeNewPasswordDialog() {
        this.dialogNewPassword = false,
        this.newpassword = '',
        this.newpasswordConfirmation = ''
      },
      saveNewPassword(){
        this.dialogNewPassword = false
        this.dialogNewPasswordConfirm = false

        if (this.newpassword === this.newpasswordConfirmation) {

          let adminData = this.$store.getters['users/getAdminData']; 
          let postObj = {
            "strict": true,
            "value": {
                "op": "PROFILEUPDATE",
                "id": this.adminUserData.id,
                "accountId": this.adminUserData.accountId,
                "sessionId": adminData.sessionId,
                "data": {
                  "username": this.adminUserData.username,
                  "password": this.newpasswordConfirmation,
                  "adminName": this.adminUserData.adminName,
                  "role": "admin"
                }
            }
          }
          admin.adminOps(postObj).then(response => {
            this.showSnack('Password Updated Successfully!', false);
            this.resetPasswordValidation();
            this.resetPasswordForm();
          }).catch(error => {
            console.log(`error ${JSON.stringify(error)}`);
            this.showSnack('Password Updaion failed!', true);
            this.resetPasswordValidation();
            this.resetPasswordForm();
          });
        } else {
          // Dispaly alert
          this.displayAlert = true;
          this.showAlert = { 
            type: 'error', 
            message: `${i18n.t('passwordClashing')}`,
            dismissable: true
          };
          
          this.scrollToTop();
        }
      }
    },
    computed: {
      newPasswordConfirmationRule() {
        return this.newpassword === this.newpasswordConfirmation || 'Password must match'
      }
    }
  }
</script>

<style lang="scss" scoped>
.inputs-container {
  .col-12 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .theme--light.v-input {
    padding-top: 1;
  }
  .v-input__slot {
    margin-bottom: 1;
  }
}
</style>